// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isGlobalSearchResult = objectOf({
  results: arrayOf(
    objectOf({
      type: string,
      _id: string,
      name: string,
      description: string,
      channels: arrayOf(string),
      readable_status: string,
    })
  ),
  error: boolean,
});
